<div class="contact-us-button-wrapper">
  <div class="contact-us-button-container" fxLayout="column" fxLayoutGap="1em" fxLayoutAlign="center center">
    <a [href]="link" target="_blank"  fxLayout="column" fxLayoutGap="1em" fxLayoutAlign="center center">
      <ng-container [ngSwitch]="contactMethod">
        <ng-container *ngSwitchCase="'wa'">
          <mat-icon  svgIcon="fi_whatsapp"></mat-icon>
          <span>{{ 'CONTACT_BUTTON.TALK_TO_REPRESENTATIVE' | translate }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'mail'">
          <mat-icon  svgIcon="fi_email"></mat-icon>
          <span>{{ 'CONTACT_BUTTON.TALK_TO_REPRESENTATIVE' | translate }}</span>
        </ng-container>
      </ng-container>
    </a>

  </div>
</div>
